import createIcon from '../../createIcon';

/**
 * @component @name MissedVideoCall
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTcgMTAuNVY3QzE3IDYuNDUgMTYuNTUgNiAxNiA2SDRDMy40NSA2IDMgNi40NSAzIDdWMTdDMyAxNy41NSAzLjQ1IDE4IDQgMThIMTZDMTYuNTUgMTggMTcgMTcuNTUgMTcgMTdWMTMuNUwyMSAxNy41VjYuNUwxNyAxMC41Wk0xMCAxNUw2LjExIDExLjExVjEzLjY2SDVWOS4yMkg5LjQ0VjEwLjMzSDYuODlMMTAgMTMuNDNMMTQuMjIgOS4yMUwxNSAxMEwxMCAxNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const MissedVideoCall = createIcon('MissedVideoCall', [
  [
    'path',
    {
      d: 'M17 10.5V7C17 6.45 16.55 6 16 6H4C3.45 6 3 6.45 3 7V17C3 17.55 3.45 18 4 18H16C16.55 18 17 17.55 17 17V13.5L21 17.5V6.5L17 10.5ZM10 15L6.11 11.11V13.66H5V9.22H9.44V10.33H6.89L10 13.43L14.22 9.21L15 10L10 15Z',
      key: '1nv9rg',
    },
  ],
]);

export default MissedVideoCall;
